import React, { useEffect, useState } from "react";
import { Col, Menu, Row } from "antd";
import { Footer } from "antd/es/layout/layout";

import { inspectionData } from "../inspectionData";
import ItemCards from "./ItemCards";
import "../../inspection.css";
import AddCards from "./AddCards";
import CreateWorkOrder from "./CreateWorkOrder";
import { collection, doc, getDoc, updateDoc } from "firebase/firestore";
import { db } from "../../../../../../firebase";
import { useParams } from "react-router-dom";
const { SubMenu } = Menu;

const ItemsList = ({
  isModalVisible,
  handleCancel,
  handleOk,
  companyName,
  isCompanyNameFetched,
}) => {
  const [dataInspections, setDataInspections] = useState();

  const { id } = useParams();

  useEffect(() => {
    if (!companyName) return;
    const fetchInspections = async () => {
      try {
        const userRef = collection(db, "companies", companyName, "inspections");
        const docSnapshot = await getDoc(doc(userRef, id));

        if (docSnapshot.exists()) {
          const data = docSnapshot.data();
          if (data.inspectionTemplateName && !data.inspectionDetails) {
            const templateRef = collection(
              db,
              "companies",
              companyName,
              "inspectionsTemplates"
            );

            const inspectionDocSnapshot = await getDoc(
              doc(templateRef, data.inspectionTemplateName)
            );
            console.log(
              "data.inspectionTemplateName:",
              data.inspectionTemplateName
            );
            if (inspectionDocSnapshot.exists()) {
              const newData = inspectionDocSnapshot.data();
              console.log("hello This is from template name", newData);
              const inspection = newData.inspectionDetails
                ? newData.inspectionDetails
                : inspectionData;
              setDataInspections(inspection);
            }
          } else {
            const inspection = data.inspectionDetails
              ? data.inspectionDetails
              : inspectionData;
            setDataInspections(inspection);
            console.log("else hello This is from template name");
          }
        } else {
          console.log("No inspection found with the specified ID.");
          setDataInspections(inspectionData);
        }
      } catch (error) {
        console.error(error);
        alert(error.message);
      }
    };
    fetchInspections();
  }, [companyName, isCompanyNameFetched]);

  useEffect(() => {
    // This code will run whenever `dataInspections` state changes
    if (dataInspections) {
      try {
        const userRef = collection(db, "companies", companyName, "inspections");

        const docRef = doc(userRef, id);

        updateDoc(docRef, {
          inspectionDetails: dataInspections,
        });
      } catch (error) {
        console.error(error);
        alert(error.message);
      }
    }
  }, [dataInspections]); // Add `dataInspections` as a dependency

  const handleMenuClick = (e) => {
    console.log("*****hello handleMenuClick****");

    const element = document.getElementById(e.key);
    if (element) {
      // 👇 Will scroll smoothly to the top of the next section
      element.scrollIntoView({ behavior: "smooth" });
    }
  };

  const handleParentMenuClick = (e) => {
    console.log("*****hello handleParentMenuClick****");
    console.log(e);
    // Extract the last value from the array
    const lastOpenKey = e[e.length - 1];
    // console.log(lastOpenKey)
    const element = document.getElementById(lastOpenKey);
    if (element) {
      // 👇 Will scroll smoothly to the top of the next section
      element.scrollIntoView({ behavior: "smooth" });
    }
  };

  function handleAdd(newItem) {
    const newItems = [...dataInspections, newItem];
    setDataInspections(newItems);
  }

  const handleAddItem = (newItem, id) => {
    const itemIndex = dataInspections.findIndex((obj) => obj.key === id);
    const updateItem = {
      ...dataInspections[itemIndex],
      items: [...dataInspections[itemIndex].items, newItem],
    };

    const updatedData = [
      ...dataInspections.slice(0, itemIndex),
      updateItem,
      ...dataInspections.slice(itemIndex + 1),
    ];

    setDataInspections(updatedData);
  };

  const handleItemStatus = (parentId, childId, newValue) => {
    setDataInspections(
      dataInspections.map((parent) => {
        if (parent.key === parentId) {
          return {
            ...parent,
            items: parent.items.map((child) => {
              if (child.key === childId) {
                return { ...child, isDone: newValue }; // Update the name of the child object with the matching id
              } else {
                return child;
              }
            }),
          };
        } else {
          return parent;
        }
      })
    );
  };

  const handleItemFollowUp = (parentId, childId, newValue) => {
    setDataInspections(
      dataInspections?.map((parent) => {
        if (parent.key === parentId) {
          return {
            ...parent,
            items: parent.items.map((child) => {
              if (child.key === childId) {
                return { ...child, isFollowUp: newValue }; // Update the name of the child object with the matching id
              } else {
                return child;
              }
            }),
          };
        } else {
          return parent;
        }
      })
    );
  };
  const handleItemTitle = (parentId, childId, newValue, description) => {
    setDataInspections(
      dataInspections?.map((parent) => {
        if (parent.key === parentId) {
          return {
            ...parent,
            items: parent.items.map((child) => {
              if (child.key === childId) {
                return {
                  ...child,
                  itemTitle: newValue,
                  itemDescription: description,
                }; // Update the name of the child object with the matching id
              } else {
                return child;
              }
            }),
          };
        } else {
          return parent;
        }
      })
    );
  };
  console.log(dataInspections);
  function deleteItem(id) {
    const newData = dataInspections?.filter((item) => item.key !== id);
    setDataInspections(newData);
  }
  function deleteItemsByKey(keyToDelete) {
    const newData = dataInspections.forEach((obj) => {
      obj.items = obj.items.filter((item) => item.key !== keyToDelete);
    });
    setDataInspections(newData);
  }

  const menus = [];
  dataInspections?.map((item) =>
    menus.push({
      key: item.key,
      title: item.itemCardTitle,
      subMenus: item.items?.map((child) => ({
        key: child.key,
        title: child.itemTitle,
      })),
    })
  );

  return (
    <div>
      {dataInspections ? (
        <>
          <br />
          <Row justify="center">
            <Col span={12}>
              <Row gutter={16}>
                <Col span={4}>
                  <div className="sticky-top">
                    {menus?.length > 0 && (
                      <Menu
                        mode="inline"
                        onOpenChange={handleParentMenuClick}
                        onClick={handleMenuClick}
                      >
                        {menus?.map((menu) =>
                          menu?.subMenus?.length > 0 ? (
                            <SubMenu key={menu.key} title={menu.title}>
                              {menu?.subMenus?.map((subMenu) => (
                                <Menu.Item key={subMenu.key}>
                                  {subMenu.title}
                                </Menu.Item>
                              ))}
                            </SubMenu>
                          ) : (
                            <Menu.Item key={menu.key}>{menu.title}</Menu.Item>
                          )
                        )}
                      </Menu>
                    )}
                  </div>
                </Col>
                <Col span={20} style={{ overflowX: "auto" }}>
                  {dataInspections?.map((item, index) => (
                    <ItemCards
                      key={item.key}
                      data={item}
                      onAdd={handleAddItem}
                      deleteItem={deleteItem}
                      deleteItemsByKey={deleteItemsByKey}
                      onUpdateItemStatus={handleItemStatus}
                      onUpdateItemFollowUp={handleItemFollowUp}
                      onEdit={handleItemTitle}
                    />
                  ))}
                  <AddCards onAdd={handleAdd} />
                  <Footer
                    style={{
                      textAlign: "center",
                    }}
                  >
                    Copyright SayEagle © 2023
                  </Footer>
                </Col>
              </Row>
            </Col>
          </Row>

          <CreateWorkOrder
            isModalVisible={isModalVisible}
            handleCancel={handleCancel}
            data={dataInspections}
            handleOk={handleOk}
          />
        </>
      ) : null}
    </div>
  );
};

export default ItemsList;
